import { create } from 'zustand';

export interface Toast {
  id: string;
  title?: string;
  description?: string;
  variant?: 'default' | 'success' | 'error';
}

interface ToastState {
  toasts: Toast[];
  add: (t: Omit<Toast, 'id'>) => void;
  remove: (id: string) => void;
}

export const useToastStore = create<ToastState>((set, get) => ({
  toasts: [],
  add: (t) => {
    const id = `${Date.now()}_${Math.random().toString(36).slice(2)}`;
    const toast: Toast = { id, ...t };
    // Replace all toasts with the new one (only show one toast at a time)
    set({ toasts: [toast] });
    setTimeout(() => get().remove(id), 3500);
  },
  remove: (id) => set({ toasts: get().toasts.filter((t) => t.id !== id) }),
}));

export function toastSuccess(description: string, title = 'Success'): void {
  useToastStore.getState().add({ title, description, variant: 'success' });
}
export function toastError(description: string, title = 'Error'): void {
  useToastStore.getState().add({ title, description, variant: 'error' });
}
export function toastInfo(description: string, title = 'Info'): void {
  useToastStore.getState().add({ title, description, variant: 'default' });
}
